
export default function kebabCase(subject) {
    return subject.toLowerCase().replace(/\s/g, "-");
}